import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from 'vue';
import XToolbarItem from './xToolbarItem.vue';
import { useRouter } from 'vue-router';
const __default__ = {
  name: 'XToolbarItemGroup'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    data: {
      type: [Array, Object],
      default: () => ({
        title: '',
        icon: '',
        action: '',
        loading: false,
        disabled: false,
        children: []
      })
    }
  },
  emits: ['item-click'],
  setup(__props, {
    emit: __emit
  }) {
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const isGroup = computed(() => {
      return Array.isArray(props.data);
    });
    const info = computed(() => {
      if (isGroup.value) {
        return {
          title: '',
          type: 'default',
          icon: '',
          action: '',
          loading: false,
          disabled: false,
          children: []
        };
      }
      const {
        title,
        icon = '',
        type = 'default',
        action = '',
        loading = false,
        disabled = false,
        children
      } = props.data;
      return {
        title,
        icon,
        type,
        loading,
        disabled,
        action,
        children
      };
    });
    const handleItemClick = item => {
      emit('item-click', item);
      if (typeof item.action === 'string') {
        router.push({
          path: item.action
        });
      } else if (typeof item.action === 'function') {
        item.action();
      }
    };
    return (_ctx, _cache) => {
      const _component_vxe_button_group = _resolveComponent("vxe-button-group");
      return isGroup.value ? (_openBlock(), _createBlock(_component_vxe_button_group, {
        key: 0,
        round: false
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
          return _openBlock(), _createBlock(XToolbarItem, {
            key: index,
            title: item.title,
            icon: item.icon,
            action: item.action,
            loading: item.loading,
            disabled: item.disabled,
            children: item.children,
            type: item.type,
            onItemClick: handleItemClick
          }, null, 8, ["title", "icon", "action", "loading", "disabled", "children", "type"]);
        }), 128))]),
        _: 1
      })) : (_openBlock(), _createBlock(XToolbarItem, {
        key: 1,
        title: info.value.title,
        type: info.value.type,
        icon: info.value.icon,
        action: info.value.action,
        loading: info.value.loading,
        disabled: info.value.disabled,
        children: info.value.children,
        onItemClick: handleItemClick
      }, null, 8, ["title", "type", "icon", "action", "loading", "disabled", "children"]));
    };
  }
});